import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {useCallback, useSyncExternalStore} from 'react'

const subscribe = (onHashChange: () => void) => {
  window.addEventListener('hashchange', onHashChange)
  return () => window.removeEventListener('hashchange', onHashChange)
}

const subscribeToHydration = () => () => {}
const getHash = () => ssrSafeLocation.hash
const getServerHash = () => ''
const getHydrated = () => true
const getServerHydrated = () => false

export const useHash = () => {
  const hash = useSyncExternalStore(subscribe, getHash, getServerHash)
  const hydrated = useSyncExternalStore(subscribeToHydration, getHydrated, getServerHydrated)

  const updateHash = useCallback(
    (newHash: string) => {
      if (newHash !== hash) ssrSafeLocation.hash = newHash
    },
    [hash],
  )

  return [hash, updateHash, hydrated] as const
}
